import React, { FC } from 'react';
import styles from './item_separator.module.scss';

type Props = {};

export const ItemSeparator: FC<Props> = () => (
  <hr className={styles.separator} />
);
